module.exports = __webpack_public_path__ + "img/ouencampaign.ed7da5ee.jpg";